import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useFeedback } from '../../hooks/useFeedback';
import { apiParamsState } from '../../storage/app';
import { useNotification } from '../notifications/hooks/useNotification';

function NotificationsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const { loadNotificationsList } = useNotification();
  const { showFailFeedback } = useFeedback();

  useEffect(() => {
    const invalid = !apiParams?.clientId || !apiParams?.subClientId;
    if (invalid) return;

    const loadNotifications = async () => {
      const response = await loadNotificationsList();
      if (response?.error) {
        showFailFeedback(response.error || 'Ocurrió un error al cargar las notificaciones.');
      }
    };
    loadNotifications();
  }, [apiParams?.clientId, apiParams?.subClientId]);

  return null;
}

export default NotificationsProvider;
